<script>
	import { Table, DropdownItem } from "sveltestrap";
	import CustomPaginate from "../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import BsLoader from "../../../../components/Loader/BsLoader.svelte";
	import { convert } from "../../../../services/helpers";
	import { loadingStatus, efficiencyEditData } from "../../../../store/store";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let handleStatusChange;
	export let handleDelete;
	export let idStatus;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Vehicle Model</th>
				<th>Vehicle Make</th>
				<th>Fuel Type</th>
				<th class="col-2">EV max. <br />distance (km)</th>
				<th class="col-2">Fuel (L)/Battery <br />Capacity (kWh)</th>
				<th class="col-2">Fuel/Battery <br />Efficiency (km)</th>
				<th>Created On</th>
				<th class="col-2 text-center">Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, modelName, modelId, makeId, name, makeName, typeId, typeName, createdAt, status, fuelName, fuelId, evMaxDistance, fuelBattEfficiencyKm, fuelBattCapacityKwh, fuelConsumptionOrEfficiency, fuelTankSizeOrCapacity }}
				<tr>
					<td>
						<p>
							<span>
								{modelName}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{makeName}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{fuelName ? fuelName : "-"}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{evMaxDistance ? evMaxDistance : "-"}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{fuelTankSizeOrCapacity}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{fuelConsumptionOrEfficiency}
							</span>
						</p>
					</td>
					<td>
						{convert(createdAt)}
					</td>
					<td class="px-5">
						{#if status}
							{#if $loadingStatus && idStatus == id}
								<p>&nbsp; &nbsp; <BsLoader /></p>
							{:else}
								<p
									class="status-bar status-bar-1 mx-auto my-auto"
								>
									Active
								</p>
							{/if}
						{:else if $loadingStatus && idStatus == id}
							<p>&nbsp; &nbsp; <BsLoader /></p>
						{:else}
							<p class="status-bar status-bar-3 mx-auto my-auto">
								Inactive
							</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							{#if status}
								<!-- This endpoint needs presetTaskId not returned by fetch api -->
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
							<DropdownItem on:click={() => handleDelete(id)}
								>Delete</DropdownItem
							>
							<DropdownItem
								on:click={() => {
									efficiencyEditData.set({
										vehicleModelId: modelId,
										vehicleMakeId: makeId,
										vehicleFuelId: fuelId,
										evMaxDistanceKm: evMaxDistance,
										capacity: fuelTankSizeOrCapacity,
										efficiency: fuelConsumptionOrEfficiency,
									});
									navigate(
										`/master-data/vehicle-data/vehicle-efficiency/edit/${id}`
									);
								}}>Edit</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.length} />
</LoaderContainer>
